// frontend/src/api/api.js
// این فایل به عنوان یک Wrapper عمل می‌کند تا مسیر ایمپورت‌ها در صفحات (مثل SubCategoriesPage)
// با مسیر واقعی فایل نهایی API شما (services/api.js) سازگار شود.

// 💡 مطمئن شوید که مسیر زیر به فایل نهایی شما (services/api.js) اشاره دارد.
import api from '../services/api'; 

export default api;